import React from "react";
import LabelWithInputDisabled from "../../../components/generic/LabelWithInputDisabled";

function EventMonitorView({
  eventType,
  matchType,
  fileName,
  sql,
  environmentName,
  dbConnection,
  pollIntervalSeconds,
  pollTimeoutSeconds,
}) {
  const isFile = eventType === "File received in a location";
  const isSql = eventType === "SQL Event";

  return (
    <div>
      <LabelWithInputDisabled label="Event Type" value={eventType || "—"} />

      {isFile && (
        <>
          <LabelWithInputDisabled label="Match Type" value={matchType || "—"} />
          <LabelWithInputDisabled
            label="File Name"
            value={fileName || "Any file"}
          />
        </>
      )}

      {isSql && (
        <>
          <LabelWithInputDisabled
            label="Environment"
            value={environmentName || "—"}
          />
          <LabelWithInputDisabled
            label="Database"
            value={dbConnection || "—"}
          />
          {sql && (
            <div style={{ margin: "8px 0" }}>
              <p
                style={{
                  fontSize: 12,
                  color: "var(--color-text-secondary)",
                  marginBottom: 4,
                }}
              >
                SQL Query
              </p>
              <pre
                style={{
                  background: "#0B1F3A",
                  color: "#86EFAC",
                  padding: "10px 14px",
                  borderRadius: 6,
                  fontSize: 12,
                  fontFamily: "monospace",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-all",
                  margin: 0,
                }}
              >
                {sql}
              </pre>
            </div>
          )}
        </>
      )}

      <LabelWithInputDisabled
        label="Poll every"
        value={pollIntervalSeconds ? `${pollIntervalSeconds}s` : "10s"}
      />
      <LabelWithInputDisabled
        label="Timeout"
        value={pollTimeoutSeconds ? `${pollTimeoutSeconds}s` : "300s"}
      />
    </div>
  );
}

export default EventMonitorView;
